// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"personalLoansVideo_wrapper__Q1gSt","video":"personalLoansVideo_video__6ukuC","isVisible":"personalLoansVideo_isVisible__RePWa","hide":"personalLoansVideo_hide__U3kTG"};